import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import com.example.histoire.createHttpClient
import com.example.histoire.web.ChildProfilesOnboarding
import com.example.histoire.web.ResolvedReaderTheme
import com.example.histoire.web.ageDisplayForBirthDate
import com.example.histoire.web.averageImageDataUrlLuminance
import com.example.histoire.web.loadAppBackgroundDataUrl
import com.example.histoire.web.loadReaderUiPrefs
import com.example.histoire.web.resolveReaderTheme
import com.example.histoire.web.saveAppBackgroundDataUrl
import com.example.histoire.web.saveReaderUiPrefs
import com.example.histoire.web.clearSupabaseWebSession
import com.example.histoire.web.clearInTabAppUnlock
import com.example.histoire.web.consumeBiometricReenabledNoticePending
import com.example.histoire.web.consumeOpenParentProfileOncePending
import com.example.histoire.web.consumeSupabaseAuthRedirect
import com.example.histoire.web.resetStaleRecoveryClientStateOnReload
import com.example.histoire.web.currentSupabaseAuthEmail
import com.example.histoire.web.fetchChildProfilesFromSupabase
import com.example.histoire.web.enrollPasskeyForCurrentUser
import com.example.histoire.web.resetPasskeysForCurrentUser
import com.example.histoire.web.supabaseAccessTokenForStory
import com.example.histoire.web.FamilySettingsMenu
import com.example.histoire.web.hasPasskeyForCurrentUser
import com.example.histoire.web.hasSupabaseUserSession
import com.example.histoire.web.hasRecoveryUiLock
import com.example.histoire.web.hasRecoveryPendingFlag
import com.example.histoire.web.hasInTabAppUnlock
import com.example.histoire.web.loadUserProfileOnboardingInfo
import com.example.histoire.web.isSupabaseWebConfigured
import com.example.histoire.web.isPasskeyEnrollmentSupported
import com.example.histoire.web.isPasskeyHintEnabledLocally
import com.example.histoire.web.loadStoredChildProfiles
import com.example.histoire.web.replaceChildProfilesOnSupabase
import com.example.histoire.web.saveStoredChildProfiles
import com.example.histoire.web.setPasskeyHintEnabledLocally
import com.example.histoire.web.ParentIdentityOnboarding
import com.example.histoire.web.StoredChildProfile
import com.example.histoire.web.SupabaseEmailLoginCard
import com.example.histoire.web.UserFacingError
import com.example.histoire.web.UserFacingErrorKind
import com.example.histoire.web.frenchUserFacingError
import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.request.post
import io.ktor.client.request.setBody
import io.ktor.http.ContentType
import io.ktor.http.contentType
import kotlinx.browser.localStorage
import kotlinx.browser.window
import kotlinx.coroutines.await
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import kotlinx.serialization.Serializable
import org.jetbrains.compose.web.css.Color
import org.jetbrains.compose.web.css.CSSColorValue
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.FlexDirection
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.JustifyContent
import org.jetbrains.compose.web.css.StyleScope
import org.jetbrains.compose.web.css.alignItems
import org.jetbrains.compose.web.css.backgroundColor
import org.jetbrains.compose.web.css.color
import org.jetbrains.compose.web.css.display
import org.jetbrains.compose.web.css.flexDirection
import org.jetbrains.compose.web.css.flexWrap
import org.jetbrains.compose.web.css.fontFamily
import org.jetbrains.compose.web.css.fontSize
import org.jetbrains.compose.web.css.justifyContent
import org.jetbrains.compose.web.css.margin
import org.jetbrains.compose.web.css.padding
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.gap
import org.jetbrains.compose.web.css.width
import org.jetbrains.compose.web.css.minHeight
import org.jetbrains.compose.web.css.maxWidth
import org.jetbrains.compose.web.css.textAlign
import org.jetbrains.compose.web.dom.Button
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.TextArea
import org.jetbrains.compose.web.dom.Text
import org.jetbrains.compose.web.dom.Input
import org.jetbrains.compose.web.dom.Img
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.renderComposable
import kotlin.js.Promise

private data class StoryGenerationErrorDialogState(
    val title: String,
    val error: UserFacingError,
    val reportContext: String,
)

private data class StoryGenerationConfirmDialogState(
    val childrenDisplay: String,
    val themeDisplay: String,
)

private data class PendingStoryGeneration(
    val hero: String,
    val effectivePromptWithHero: String,
)

private data class SupportReportDraft(
    val screenLabel: String,
    val category: String,
    val summary: String,
    val technicalNote: String,
)

private data class SupportCategoryOption(
    val code: String,
    val label: String,
)

private val supportCategories = listOf(
    SupportCategoryOption("rapport_bug", "Rapport de bug"),
    SupportCategoryOption("demande_developpement", "Demande de développement / Amélioration"),
)
private const val FORM_FOCUS_SCROLL_JS =
    "this.scrollIntoView({behavior:'smooth', block:'center'});"
private const val FORM_ENTER_NEXT_JS =
    "if(event.key==='Enter'){event.preventDefault();const scope=this.closest('[data-enter-scope]')||document;" +
        "const els=[...scope.querySelectorAll('input,button,textarea,select')]" +
        ".filter(e=>!e.disabled&&e.offsetParent!==null);" +
        "const i=els.indexOf(this);if(i>=0&&i<els.length-1){els[i+1].focus({preventScroll:true});" +
        "els[i+1].scrollIntoView({behavior:'smooth',block:'center'});}}"

fun main() {
    stripLegacyInviteFromBrowserUrl()
    renderComposable(rootElementId = "root") {
        WebApp()
    }
}

/** Anciens liens /hamza, ?invite=hamza, etc. : on ramène l’URL sur / (objectif A, pas d’invitations). */
private fun stripLegacyInviteFromBrowserUrl() {
    val legacy = setOf("hamza", "sarah", "graziella", "h", "s", "g")
    val path = window.location.pathname.trim().trimEnd('/')
    val segments = path.removePrefix("/").split("/").filter { it.isNotBlank() }

    var newPath = path.ifBlank { "/" }
    if (segments.size == 1 && segments[0].lowercase() in legacy) {
        newPath = "/"
    } else if (segments.size == 2 && segments[0].lowercase() == "invite" && segments[1].lowercase() in legacy) {
        newPath = "/"
    }

    val rawSearch = window.location.search.removePrefix("?")
    val newQuery =
        if (rawSearch.isBlank()) {
            ""
        } else {
            rawSearch
                .split("&")
                .mapNotNull { pair ->
                    if (pair.isBlank()) return@mapNotNull null
                    val idx = pair.indexOf('=')
                    val key = (if (idx >= 0) pair.substring(0, idx) else pair).lowercase()
                    val value = if (idx >= 0) pair.substring(idx + 1) else ""
                    if (key == "invite" && value.lowercase() in legacy) null else pair
                }
                .joinToString("&")
        }

    val newSearch = if (newQuery.isBlank()) "" else "?$newQuery"
    if (newPath != window.location.pathname || newSearch != window.location.search) {
        val url = window.location.origin + newPath + newSearch + window.location.hash
        window.history.replaceState(window.history.state, "", url)
    }
}

private fun urlLooksLikeRecoveryFlow(): Boolean {
    val hash = window.location.hash.removePrefix("#")
    val search = window.location.search.removePrefix("?")
    val all = (hash + "&" + search).lowercase()
    return "type=recovery" in all
}

@Composable
private fun WebApp() {
    val profile = personalizedProfile()
    val usesFamilyChildProfiles = !profile.isAdmin && profile.inviteCode == "standard"
    val supabaseConfigured = remember {
        resetStaleRecoveryClientStateOnReload()
        isSupabaseWebConfigured()
    }
    val recoveryHintFromUrl = remember { supabaseConfigured && urlLooksLikeRecoveryFlow() }
    val initialStoredProfiles = remember { loadStoredChildProfiles() }
    var storedChildProfiles by remember { mutableStateOf(initialStoredProfiles) }
    var familyProfilesRemoteReady by remember {
        mutableStateOf(!usesFamilyChildProfiles || !supabaseConfigured)
    }
    var needSupabaseEmailLogin by remember { mutableStateOf(recoveryHintFromUrl) }
    var forceRecoveryReset by remember { mutableStateOf(recoveryHintFromUrl) }
    var reopenProfileSetup by remember { mutableStateOf(false) }
    var showParentIdentitySetup by remember { mutableStateOf(false) }
    var parentInitialFirst by remember { mutableStateOf("") }
    var parentInitialLast by remember { mutableStateOf("") }
    var parentInitialEmail by remember { mutableStateOf("") }
    val showChildProfileSetup =
        familyProfilesRemoteReady && usesFamilyChildProfiles && !showParentIdentitySetup &&
            (storedChildProfiles.isEmpty() || reopenProfileSetup)
    var settingsMenuOpen by remember { mutableStateOf(false) }
    val baseUrl = window.location.origin
    val displayName = profile.displayName.replaceFirstChar { it.uppercase() }
    val weeklyTheme = weeklyThemeForInvite(profile.inviteCode)
    val themeOptions = deepenWeeklyThemeOptionsForHome(weeklyTheme)
    val coroutineScope = rememberCoroutineScope()
    val client = remember { createHttpClient() }
    var selectedTheme by remember { mutableStateOf(weeklyTheme.uiTheme) }
    var childName by remember { mutableStateOf(displayName) }
    var childAge by remember { mutableStateOf("") }
    var ageUnit by remember { mutableStateOf("ans") }
    var storyPrompt by remember { mutableStateOf(weeklyTheme.prompt) }
    var customTheme by remember { mutableStateOf("") }
    var heroName by remember { mutableStateOf("") }
    var generatedStory by remember { mutableStateOf(profile.defaultStory) }
    var isLoading by remember { mutableStateOf(false) }
    var errorMessage by remember { mutableStateOf<String?>(null) }
    var storyErrorDialog by remember { mutableStateOf<StoryGenerationErrorDialogState?>(null) }
    var storyConfirmDialog by remember { mutableStateOf<StoryGenerationConfirmDialogState?>(null) }
    var pendingGeneration by remember { mutableStateOf<PendingStoryGeneration?>(null) }
    var supportDialogDraft by remember { mutableStateOf<SupportReportDraft?>(null) }
    var settingsMessage by remember { mutableStateOf<String?>(null) }
    var biometricUnlockEnabled by remember { mutableStateOf(isPasskeyHintEnabledLocally()) }
    /** Remplace le bloc thème / génération par le texte de l’histoire (fond transparent). */
    var storyReadingMode by remember { mutableStateOf(false) }
    var appBackgroundDataUrl by remember { mutableStateOf(loadAppBackgroundDataUrl()) }
    var readerPrefs by remember { mutableStateOf(loadReaderUiPrefs()) }
    var backgroundImageLuminance by remember { mutableStateOf<Double?>(null) }
    val background = backgroundForTheme(selectedTheme)
    val ageLocked = usesFamilyChildProfiles && storedChildProfiles.isNotEmpty()
    val nameLocked = profile.lockName || ageLocked
    val suggestedHeroName = remember(storedChildProfiles) {
        storedChildProfiles
            .map { it.firstName.trim() }
            .filter { it.isNotBlank() }
            .distinct()
            .joinToString(", ")
    }

    val readerShellActive =
        !profile.isAdmin &&
            usesFamilyChildProfiles &&
            storedChildProfiles.isNotEmpty() &&
            !showChildProfileSetup &&
            !(supabaseConfigured && needSupabaseEmailLogin) &&
            !(supabaseConfigured && showParentIdentitySetup)

    val bgUrl = appBackgroundDataUrl
    val hasCustomPhotoBackground =
        !bgUrl.isNullOrBlank() && bgUrl.trim().startsWith("data:image/")

    val readerTheme =
        remember(readerPrefs, backgroundImageLuminance, hasCustomPhotoBackground, readerShellActive) {
            resolveReaderTheme(
                readerPrefs,
                backgroundImageLuminance,
                hasCustomPhotoBackground,
                readerShellActive,
            )
        }

    LaunchedEffect(Unit) {
        if (consumeBiometricReenabledNoticePending()) {
            settingsMessage = "Déverrouillage biométrique réactivé."
        }
    }

    LaunchedEffect(appBackgroundDataUrl, readerShellActive, storedChildProfiles.size) {
        if (!readerShellActive) {
            backgroundImageLuminance = null
            return@LaunchedEffect
        }
        val url = appBackgroundDataUrl?.trim().orEmpty()
        backgroundImageLuminance =
            if (url.startsWith("data:image/")) {
                averageImageDataUrlLuminance(url)
            } else {
                null
            }
    }

    LaunchedEffect(suggestedHeroName) {
        if (heroName.isBlank() && suggestedHeroName.isNotBlank()) {
            heroName = suggestedHeroName
        }
    }

    LaunchedEffect(usesFamilyChildProfiles, supabaseConfigured) {
        // Sur une vraie ouverture (navigation), on exige un nouvel unlock local.
        // On conserve le marqueur seulement pour un simple reload post-login.
        val navigationType = runCatching {
            js(
                """(function(){
                    var e = (performance && performance.getEntriesByType) ? performance.getEntriesByType('navigation') : null;
                    if (e && e.length > 0 && e[0] && e[0].type) return String(e[0].type);
                    return '';
                })()""",
            ).unsafeCast<String>().lowercase()
        }.getOrDefault("")
        if (isPasskeyHintEnabledLocally() && navigationType != "reload") {
            clearInTabAppUnlock()
        }

        if (supabaseConfigured) {
            // Très important : consommer immédiatement le lien auth/recovery (hash/query)
            // pour poser les flags locaux avant de décider quel écran afficher.
            runCatching {
                consumeSupabaseAuthRedirect(
                    client = client,
                    allowRecoveryConsumption = !recoveryHintFromUrl,
                )
            }
        }

        if (supabaseConfigured && (recoveryHintFromUrl || hasRecoveryPendingFlag() || hasRecoveryUiLock())) {
            forceRecoveryReset = true
            needSupabaseEmailLogin = true
            familyProfilesRemoteReady = true
            showParentIdentitySetup = false
            return@LaunchedEffect
        }

        if (!usesFamilyChildProfiles || !supabaseConfigured) {
            familyProfilesRemoteReady = true
            needSupabaseEmailLogin = false
            forceRecoveryReset = hasRecoveryUiLock()
            showParentIdentitySetup = false
            return@LaunchedEffect
        }
        // Verrou à la réouverture: si biométrie activée, exiger une authentification par session d'onglet.
        if (isPasskeyHintEnabledLocally() && !hasInTabAppUnlock()) {
            clearSupabaseWebSession()
            needSupabaseEmailLogin = true
            forceRecoveryReset = false
            showParentIdentitySetup = false
            familyProfilesRemoteReady = true
            return@LaunchedEffect
        }
        familyProfilesRemoteReady = false
        needSupabaseEmailLogin = false
        try {
            if (!hasSupabaseUserSession(client)) {
                needSupabaseEmailLogin = true
                forceRecoveryReset = hasRecoveryUiLock()
                showParentIdentitySetup = false
            } else {
                // Lien "mot de passe oublié" : forcer l'écran auth pour afficher le formulaire reset.
                if (hasRecoveryPendingFlag() || hasRecoveryUiLock()) {
                    forceRecoveryReset = true
                    needSupabaseEmailLogin = true
                    showParentIdentitySetup = false
                    return@LaunchedEffect
                }
                needSupabaseEmailLogin = false
                forceRecoveryReset = hasRecoveryUiLock()
                when (val remote = fetchChildProfilesFromSupabase(client)) {
                    null -> { /* erreur réseau ou auth : conserver le cache local */ }
                    else -> {
                        if (remote.isNotEmpty()) {
                            saveStoredChildProfiles(remote)
                            storedChildProfiles = remote
                        } else {
                            // Nouveau compte (ou compte sans enfants) :
                            // ne pas réinjecter l'ancien cache local dans Supabase,
                            // afin d'afficher correctement l'étape wizard "profil enfants".
                            saveStoredChildProfiles(emptyList())
                            storedChildProfiles = emptyList()
                        }
                    }
                }
                val parentInfo = loadUserProfileOnboardingInfo(client)
                parentInitialFirst = parentInfo.initialFirstName
                parentInitialLast = parentInfo.initialLastName
                parentInitialEmail = parentInfo.initialContactEmail
                val openParentOnce = consumeOpenParentProfileOncePending()
                showParentIdentitySetup = openParentOnce || parentInfo.needsParentIdentityForm
            }
        } finally {
            familyProfilesRemoteReady = true
        }
    }

    val title = when {
        usesFamilyChildProfiles && storedChildProfiles.isNotEmpty() -> familyStoryTitle(storedChildProfiles)
        displayName == "Ami" -> "Histoire du soir"
        else -> "Histoire pour $displayName"
    }

    val showEmailLogin =
        (usesFamilyChildProfiles && supabaseConfigured && needSupabaseEmailLogin) ||
            (supabaseConfigured && forceRecoveryReset)
    val showParentIdentitySetupScreen =
        usesFamilyChildProfiles && supabaseConfigured && showParentIdentitySetup
    /** Pas de fond photo utilisateur sur connexion et profil parent : même ambiance + illustration dans la carte. */
    val useFamilyBrandShell = showEmailLogin || showParentIdentitySetupScreen
    val pageFillColor = if (useFamilyBrandShell) Color("#1a1028") else background
    val pageCustomBackground = if (useFamilyBrandShell) null else appBackgroundDataUrl

    Div({ style { pageContainer(pageFillColor, pageCustomBackground, readerTheme.primary) } }) {
        Div({ style { appCard() } }) {
            if (profile.isAdmin) {
                H1({ style { titleText(readerTheme) } }) {
                    Text("Espace Admin")
                }
                P({ style { descriptionText(readerTheme) } }) {
                    Text("Partage ces liens personnalisés avec chaque enfant.")
                }
                Div({ style { storyCard() } }) {
                    adminLinkLine("Admin", "$baseUrl/admin")
                    adminLinkLine("Admin (court)", "$baseUrl/a")
                    adminLinkLine("Standard", "$baseUrl/")
                }
                return@Div
            }

            if (usesFamilyChildProfiles && supabaseConfigured && !familyProfilesRemoteReady) {
                P({ style { descriptionText(readerTheme) } }) { Text("Chargement de tes profils…") }
                return@Div
            }

            if (showEmailLogin) {
                SupabaseEmailLoginCard(client = client, onLoggedIn = { window.location.reload() })
                return@Div
            }

            if (usesFamilyChildProfiles && supabaseConfigured && showParentIdentitySetup) {
                ParentIdentityOnboarding(
                    client = client,
                    initialFirstName = parentInitialFirst,
                    initialLastName = parentInitialLast,
                    initialContactEmail = parentInitialEmail,
                    onComplete = { showParentIdentitySetup = false },
                )
                return@Div
            }

            if (usesFamilyChildProfiles && showChildProfileSetup) {
                ChildProfilesOnboarding(
                    initialProfiles = storedChildProfiles,
                    initialBackgroundDataUrl = appBackgroundDataUrl,
                    allowDismiss = storedChildProfiles.isNotEmpty(),
                    onComplete = { list, backgroundUrl ->
                        reopenProfileSetup = false
                        saveAppBackgroundDataUrl(backgroundUrl)
                        appBackgroundDataUrl = loadAppBackgroundDataUrl()
                        coroutineScope.launch {
                            if (supabaseConfigured) {
                                if (replaceChildProfilesOnSupabase(client, list)) {
                                    storedChildProfiles = loadStoredChildProfiles()
                                } else {
                                    saveStoredChildProfiles(list)
                                    storedChildProfiles = list
                                }
                            } else {
                                saveStoredChildProfiles(list)
                                storedChildProfiles = list
                            }
                        }
                    },
                    onDismiss = { reopenProfileSetup = false },
                )
                return@Div
            }

            if (profile.photoUrl.isNotBlank()) {
                Div({ style { centeredMedia() } }) {
                    Img(src = profile.photoUrl, attrs = {
                        attr("alt", "Photo de ${profile.displayName}")
                        style { photoStyle() }
                    })
                }
            } else if (profile.isAdmin && profile.avatar.isNotBlank()) {
                Div({ style { centeredMedia() } }) {
                    Div({ style { avatarBadge() } }) {
                        Text(profile.avatar)
                    }
                }
            }
            Div({ style { readerMainColumn(readerTheme) } }) {
            H1({ style { titleText(readerTheme) } }) {
                Text(title)
            }
            P({ style { descriptionText(readerTheme) } }) {
                Text(profile.welcomeMessage)
            }
            if (settingsMessage != null) {
                P({ style { descriptionText(readerTheme) } }) { Text(settingsMessage!!) }
            }
            if (usesFamilyChildProfiles && storedChildProfiles.isNotEmpty()) {
                FamilySettingsMenu(
                    open = settingsMenuOpen,
                    onToggleOpen = { settingsMenuOpen = !settingsMenuOpen },
                    onOpenChildProfiles = {
                        settingsMenuOpen = false
                        reopenProfileSetup = true
                    },
                    biometricUnlockEnabled = biometricUnlockEnabled,
                    onToggleBiometricUnlock = { enabled ->
                        settingsMenuOpen = false
                        if (!enabled) {
                            biometricUnlockEnabled = false
                            setPasskeyHintEnabledLocally(false)
                            settingsMessage = "Déverrouillage biométrique désactivé."
                        } else {
                            if (!isPasskeyEnrollmentSupported()) {
                                settingsMessage = "Cet appareil ne supporte pas encore le déverrouillage biométrique sur ce navigateur."
                                return@FamilySettingsMenu
                            }
                            coroutineScope.launch {
                                val err = enrollPasskeyForCurrentUser(client)
                                if (err == null) {
                                    var hasPasskey = false
                                    repeat(4) { attempt ->
                                        hasPasskey = hasPasskeyForCurrentUser(client)
                                        if (hasPasskey) return@repeat
                                        if (attempt < 3) delay(500)
                                    }
                                    if (hasPasskey) {
                                        biometricUnlockEnabled = true
                                        setPasskeyHintEnabledLocally(true)
                                        val authEmail = currentSupabaseAuthEmail(client)?.trim().orEmpty()
                                        if (authEmail.contains('@')) {
                                            localStorage.setItem("histoire_last_login_email_v1", authEmail)
                                        }
                                        settingsMessage = "Déverrouillage biométrique activé."
                                    } else {
                                        biometricUnlockEnabled = true
                                        setPasskeyHintEnabledLocally(true)
                                        settingsMessage = "Activation biométrique à vérifier: reconnecte-toi puis réessaie si besoin."
                                    }
                                } else {
                                    settingsMessage = err
                                }
                            }
                        }
                    },
                    onResetBiometricUnlock = {
                        settingsMenuOpen = false
                        coroutineScope.launch {
                            val err = resetPasskeysForCurrentUser(client)
                            if (err == null) {
                                biometricUnlockEnabled = false
                                setPasskeyHintEnabledLocally(false)
                                settingsMessage = "Biométrie réinitialisée sur ce compte. Tu peux la réactiver."
                            } else {
                                settingsMessage = err
                            }
                        }
                    },
                    onContactSupport = {
                        settingsMenuOpen = false
                        supportDialogDraft = SupportReportDraft(
                            screenLabel = "menu_parametres_web",
                            category = "demande_developpement",
                            summary = "",
                            technicalNote = "",
                        )
                    },
                    onLogout = {
                        settingsMenuOpen = false
                        clearSupabaseWebSession()
                        window.location.reload()
                    },
                    readerPrefs = readerPrefs,
                    onReaderPrefsChange = { p ->
                        saveReaderUiPrefs(p)
                        readerPrefs = p
                    },
                    detectedImageLuminance = backgroundImageLuminance,
                )
            }
            P({ style { descriptionText(readerTheme) } }) {
                Text("Thème de la semaine : ${weeklyTheme.label}")
            }
            if (customTheme.trim().isNotBlank()) {
                P({ style { customBadge() } }) {
                    Text("Thème actif: Personnalisé")
                }
            }
            if (usesFamilyChildProfiles && storedChildProfiles.isNotEmpty()) {
                P({ style { labelText(readerTheme) } }) { Text("Héros de l'histoire") }
                P({ style { descriptionText(readerTheme) } }) {
                    Text(
                        "Une seule histoire inclut tous les enfants du compte : " +
                            familyChildrenSummaryText(storedChildProfiles),
                    )
                }
            } else {
                Div({ style { formRow() } }) {
                    Div({ style { firstNameField() } }) {
                        P({ style { labelText(readerTheme) } }) { Text("Prénom") }
                        Input(type = InputType.Text, attrs = {
                            value(childName)
                            onInput { event -> childName = event.value }
                            attr("onfocus", FORM_FOCUS_SCROLL_JS)
                            attr("onkeydown", FORM_ENTER_NEXT_JS)
                            if (nameLocked) attr("disabled", "true")
                            style { inputBox(readerTheme) }
                        })
                    }
                    Div({ style { ageField() } }) {
                        P({ style { labelText(readerTheme) } }) { Text("Âge") }
                        if (ageLocked) {
                            P({ style { descriptionText(readerTheme) } }) {
                                val unitLabel = if (ageUnit == "ans") "ans" else "mois"
                                Text(
                                    "${childAge.trim().ifBlank { "?" }} $unitLabel " +
                                        "(mis à jour automatiquement selon la date de naissance)",
                                )
                            }
                        } else {
                            Div({ style { ageRow() } }) {
                                Input(type = InputType.Text, attrs = {
                                    value(childAge)
                                    onInput { event -> childAge = event.value }
                                    attr("onfocus", FORM_FOCUS_SCROLL_JS)
                                    attr("onkeydown", FORM_ENTER_NEXT_JS)
                                    style { ageInputBox(readerTheme) }
                                })
                                Button(attrs = {
                                    onClick { ageUnit = if (ageUnit == "ans") "mois" else "ans" }
                                    style { unitSliderButton() }
                                }) { Text(if (ageUnit == "ans") "Ans" else "Mois") }
                            }
                        }
                    }
                }
            }
            Div({
                attr("data-enter-scope", "story-form")
                style { storyCard() }
            }) {
                if (storyReadingMode) {
                    Button(attrs = {
                        attr("type", "button")
                        onClick {
                            storyReadingMode = false
                            errorMessage = null
                        }
                        style { storyFormBackButton(readerTheme) }
                    }) { Text("← Retour au formulaire") }
                    P({ style { storyReadingTitle(readerTheme) } }) { Text("Ton histoire") }
                    P({ style { storyText(readerTheme) } }) {
                        Text(generatedStory)
                    }
                    Button(attrs = {
                        attr("type", "button")
                        onClick {
                            storyReadingMode = false
                            errorMessage = null
                        }
                        style { storyFormBackButton(readerTheme) }
                    }) { Text("Retour au formulaire") }
                } else {
                    P({ style { labelText(readerTheme) } }) {
                        Text("Univers")
                    }
                    Div({ style { themeSelectorRow() } }) {
                        themeOptions.forEach { themeOption ->
                            storyThemeButton(
                                label = themeOption.label,
                                selected = customTheme.isBlank() && storyPrompt == themeOption.prompt,
                                theme = readerTheme,
                                onClick = {
                                    storyPrompt = themeOption.prompt
                                    selectedTheme = themeOption.uiTheme
                                    customTheme = ""
                                },
                            )
                        }
                    }
                    P({ style { labelText(readerTheme) } }) {
                        Text("Ou crée ton propre thème")
                    }
                    Input(type = InputType.Text, attrs = {
                        value(customTheme)
                        onInput { event -> customTheme = event.value }
                        attr("onfocus", FORM_FOCUS_SCROLL_JS)
                        attr("onkeydown", FORM_ENTER_NEXT_JS)
                        attr("placeholder", "Ex: Pirates, Robots, Licornes...")
                        style { inputBox(readerTheme) }
                    })
                    P({ style { labelText(readerTheme) } }) {
                        Text("Qui est le héros ?")
                    }
                    Input(type = InputType.Text, attrs = {
                        value(heroName)
                        onInput { event -> heroName = event.value }
                        attr("onfocus", FORM_FOCUS_SCROLL_JS)
                        attr("onkeydown", FORM_ENTER_NEXT_JS)
                        attr("placeholder", "Ex: Léo et Inaya")
                        style { inputBox(readerTheme) }
                    })
                    Button(attrs = {
                        onClick {
                            customTheme = ""
                            errorMessage = null
                        }
                        style { clearButton() }
                    }) { Text("Effacer le thème personnalisé") }
                    Button(attrs = {
                        onClick {
                            val effectivePrompt = if (customTheme.trim().isNotBlank()) {
                                "une aventure sur le thème ${customTheme.trim()}"
                            } else {
                                storyPrompt
                            }
                            val hero = heroName.trim()
                            val effectivePromptWithHero =
                                if (hero.isBlank()) effectivePrompt else "$effectivePrompt avec $hero"
                            val childrenDisplay =
                                if (usesFamilyChildProfiles && storedChildProfiles.isNotEmpty()) {
                                    storedChildProfiles.joinToString(", ") { it.firstName.trim().ifBlank { "Enfant" } }
                                } else {
                                    childName.trim().ifBlank { "les enfants" }
                                }
                            val effectiveThemeDisplay =
                                if (customTheme.trim().isNotBlank()) customTheme.trim() else "thème de la semaine"
                            storyConfirmDialog = StoryGenerationConfirmDialogState(
                                childrenDisplay = childrenDisplay,
                                themeDisplay = effectiveThemeDisplay,
                            )
                            pendingGeneration = PendingStoryGeneration(
                                hero = hero,
                                effectivePromptWithHero = effectivePromptWithHero,
                            )
                            errorMessage = null
                        }
                        if (isLoading) attr("disabled", "true")
                        style { generateButton() }
                    }) { Text(if (isLoading) "Chargement..." else "GÉNÉRER L'HISTOIRE") }
                    if (errorMessage != null) {
                        P({ style { errorText() } }) {
                            Text(errorMessage!!)
                        }
                    }
                }
            }
            }
        }
        storyErrorDialog?.let { dialog ->
            StoryGenerationErrorDialog(
                state = dialog,
                onClose = { storyErrorDialog = null },
                onReport = { report ->
                    supportDialogDraft = report
                    storyErrorDialog = null
                },
            )
        }
        storyConfirmDialog?.let { dialog ->
            StoryGenerationConfirmDialog(
                state = dialog,
                onClose = {
                    storyConfirmDialog = null
                    pendingGeneration = null
                },
                onConfirm = {
                    val pending = pendingGeneration ?: run {
                        storyConfirmDialog = null
                        return@StoryGenerationConfirmDialog
                    }
                    storyConfirmDialog = null
                    pendingGeneration = null
                    isLoading = true
                    errorMessage = null
                    coroutineScope.launch {
                        try {
                                    val childrenLines =
                                        if (usesFamilyChildProfiles && storedChildProfiles.isNotEmpty()) {
                                            storedChildProfiles.map { p ->
                                                val a = ageDisplayForBirthDate(p.birthDateIso)
                                                ApiStoryChildLine(
                                                    name = p.firstName.trim().ifBlank { "Enfant" },
                                                    age = a.value,
                                                    ageUnit = a.unit,
                                                )
                                            }
                                        } else {
                                            null
                                        }
                                    val firstChild = storedChildProfiles.firstOrNull()
                                    val (fallbackName, fallbackAge, fallbackUnit) =
                                        if (firstChild != null) {
                                            val a = ageDisplayForBirthDate(firstChild.birthDateIso)
                                            Triple(
                                                pending.hero.ifBlank {
                                                    firstChild.firstName.trim().ifBlank { childName }
                                                }
                                                    .replaceFirstChar { it.uppercase() },
                                                a.value,
                                                a.unit,
                                            )
                                        } else {
                                            Triple(
                                                pending.hero.ifBlank { childName.trim().ifBlank { "Ami" } }
                                                    .replaceFirstChar { it.uppercase() },
                                                childAge,
                                                ageUnit,
                                            )
                                        }
                                    val storySessionToken =
                                        if (usesFamilyChildProfiles && supabaseConfigured) {
                                            supabaseAccessTokenForStory(client)
                                        } else {
                                            null
                                        }
                                    val request = ApiStoryRequest(
                                        inviteCode = profile.inviteCode,
                                        name = fallbackName,
                                        age = fallbackAge,
                                        ageUnit = fallbackUnit,
                                        theme = selectedTheme,
                                        prompt = pending.effectivePromptWithHero,
                                        children = childrenLines,
                                        supabaseAccessToken = storySessionToken?.takeIf { it.isNotBlank() },
                                    )
                                    val response: ApiStoryResponse = client.post("/api/story") {
                                        contentType(ContentType.Application.Json)
                                        setBody(request)
                                    }.body()

                                    val remoteStory = response.story?.trim().orEmpty()
                                    if (remoteStory.isBlank()) {
                                        throw IllegalStateException(
                                            response.error ?: "Réponse vide depuis le serveur",
                                        )
                                    }
                                    generatedStory = remoteStory
                                    storyReadingMode = true
                                } catch (t: Throwable) {
                                    val mapped = frenchUserFacingError(t.message ?: t.toString())
                                    storyErrorDialog = StoryGenerationErrorDialogState(
                                        title = "Generation interrompue",
                                        error = mapped,
                                        reportContext =
                                            buildString {
                                                append("Ecran: generation_histoire_web\n")
                                                append("Categorie: generation_story\n")
                                                append("Theme_ui: ")
                                                append(selectedTheme)
                                                append('\n')
                                                append("Prompt: ")
                                                append(pending.effectivePromptWithHero)
                                                append('\n')
                                                append("Detail_technique: ")
                                                append(mapped.technicalDetails.ifBlank { "n/a" })
                                            },
                                    )
                                    errorMessage = mapped.message
                                    generatedStory =
                                        if (usesFamilyChildProfiles && storedChildProfiles.isNotEmpty()) {
                                            buildStoryMulti(
                                                profiles = storedChildProfiles,
                                                theme = selectedTheme,
                                                prompt = pending.effectivePromptWithHero,
                                            )
                                        } else {
                                            buildStory(
                                                name = childName,
                                                age = childAge,
                                                ageUnit = ageUnit,
                                                theme = selectedTheme,
                                                prompt = pending.effectivePromptWithHero,
                                            )
                                        }
                                    storyReadingMode = true
                                } finally {
                                    isLoading = false
                                }
                            }
                },
            )
        }
        supportDialogDraft?.let { draft ->
            SupportContactDialog(
                initialDraft = draft,
                onClose = { supportDialogDraft = null },
                onSubmit = { report ->
                    val encryptedLogPayload = if (report.category == "rapport_bug") buildEncryptedBugLogPayload(report) else null
                    coroutineScope.launch {
                        val err = sendSupportReportDirectly(client, report, encryptedLogPayload)
                        settingsMessage = if (err == null) {
                            "Message envoyé à histoiredusoir.dev@gmail.com."
                        } else {
                            "Envoi direct impossible: $err"
                        }
                    }
                    supportDialogDraft = null
                },
            )
        }
    }
}

@Composable
private fun StoryGenerationConfirmDialog(
    state: StoryGenerationConfirmDialogState,
    onClose: () -> Unit,
    onConfirm: () -> Unit,
) {
    Div({ style { storyErrorOverlay() } }) {
        Div({
            attr("data-enter-scope", "support-dialog")
            style { storyErrorCard() }
        }) {
            H1({ style { storyErrorTitle() } }) { Text("Prêt pour la magie ?") }
            P({ style { storyErrorBody() } }) {
                Text("Je vais créer une histoire pour ${state.childrenDisplay} sur le thème \"${state.themeDisplay}\".")
            }
            Div({ style { storyErrorButtons() } }) {
                Button(attrs = {
                    attr("type", "button")
                    onClick { onClose() }
                    style { storyErrorSecondaryButton() }
                }) { Text("Modifier") }
                Button(attrs = {
                    attr("type", "button")
                    onClick { onConfirm() }
                    style { storyErrorPrimaryButton() }
                }) { Text("Oui, c'est parti !") }
            }
        }
    }
}

@Composable
private fun SupportContactDialog(
    initialDraft: SupportReportDraft,
    onClose: () -> Unit,
    onSubmit: (SupportReportDraft) -> Unit,
) {
    var category by remember(initialDraft) { mutableStateOf(initialDraft.category) }
    var summary by remember(initialDraft) { mutableStateOf(initialDraft.summary) }
    var technicalNote by remember(initialDraft) { mutableStateOf(initialDraft.technicalNote) }

    Div({ style { storyErrorOverlay() } }) {
        Div({ style { storyErrorCard() } }) {
            H1({ style { storyErrorTitle() } }) { Text("Nous contacter") }
            P({ style { storyErrorBody() } }) {
                Text("Décris le souci et on prépare le message support.")
            }

            P({ style { supportFieldLabel() } }) { Text("Catégorie") }
            Div({ style { supportCategoryRow() } }) {
                supportCategories.forEach { option ->
                    Button(attrs = {
                        attr("type", "button")
                        onClick {
                            category = option.code
                            if (summary.isBlank()) {
                                summary = suggestedSummaryForCategory(option.code)
                            }
                        }
                        style { supportCategoryChip(active = category == option.code) }
                    }) {
                        Text(option.label)
                    }
                }
            }

            P({ style { supportFieldLabel() } }) { Text("Résumé") }
            Input(type = InputType.Text, attrs = {
                value(summary)
                onInput { ev -> summary = ev.value }
                attr("onfocus", FORM_FOCUS_SCROLL_JS)
                attr("onkeydown", FORM_ENTER_NEXT_JS)
                attr("placeholder", "Ex: L'histoire ne se lance pas")
                style { supportInputBox() }
            })

            P({ style { supportFieldLabel() } }) { Text("Note technique (optionnel)") }
            TextArea(attrs = {
                value(technicalNote)
                onInput { ev -> technicalNote = ev.value }
                attr("placeholder", "Ex: message affiché, étape concernée...")
                style { supportTextAreaBox() }
            })

            Div({ style { storyErrorButtons() } }) {
                Button(attrs = {
                    attr("type", "button")
                    onClick { onClose() }
                    style { storyErrorSecondaryButton() }
                }) { Text("Annuler") }
                Button(attrs = {
                    attr("type", "button")
                    onClick {
                        onSubmit(
                            SupportReportDraft(
                                screenLabel = initialDraft.screenLabel,
                                category = category.trim().ifBlank { "demande_developpement" },
                                summary = summary.trim().ifBlank { "Aucun resume fourni" },
                                technicalNote = technicalNote.trim(),
                            ),
                        )
                    }
                    style { storyErrorPrimaryButton() }
                }) { Text("Envoyer") }
            }
        }
    }
}

@Composable
private fun StoryGenerationErrorDialog(
    state: StoryGenerationErrorDialogState,
    onClose: () -> Unit,
    onReport: (SupportReportDraft) -> Unit,
) {
    Div({ style { storyErrorOverlay() } }) {
        Div({ style { storyErrorCard() } }) {
            H1({ style { storyErrorTitle() } }) { Text(state.title) }
            P({ style { storyErrorBody() } }) { Text(state.error.message) }
            Div({ style { storyErrorButtons() } }) {
                Button(attrs = {
                    attr("type", "button")
                    onClick { onClose() }
                    style { storyErrorPrimaryButton() }
                }) { Text("OK") }
                if (state.error.kind == UserFacingErrorKind.Reportable) {
                    Button(attrs = {
                        attr("type", "button")
                        onClick {
                            onReport(
                                SupportReportDraft(
                                    screenLabel = "generation_histoire_web",
                                    category = "rapport_bug",
                                    summary = "Erreur lors de la génération de l'histoire",
                                    technicalNote = state.reportContext,
                                ),
                            )
                        }
                        style { storyErrorSecondaryButton() }
                    }) { Text("Signaler le probleme") }
                }
            }
        }
    }
}

private suspend fun sendSupportReportDirectly(
    client: HttpClient,
    report: SupportReportDraft,
    encryptedLogPayload: String?,
): String? {
    val base = com.example.histoire.web.supabaseWebUrl()
        ?: return "Supabase URL manquante."
    val anon = com.example.histoire.web.supabaseWebAnonKey()
        ?: return "Supabase ANON key manquante."
    val access = runCatching { supabaseAccessTokenForStory(client) }.getOrNull().orEmpty()
    val payload = js("{}")
    payload.category = report.category
    payload.summary = report.summary
    payload.screenLabel = report.screenLabel
    payload.technicalNote = report.technicalNote
    payload.localLogFile = if (encryptedLogPayload.isNullOrBlank()) "" else "hds_logs_chiffres.zip"
    payload.encryptedLogPayload = encryptedLogPayload ?: ""
    payload.pageUrl = window.location.href
    payload.userAgent = window.navigator.userAgent
    payload.platform = "web"
    payload.appVersion = "web-1"
    payload.browserName = detectBrowserName(window.navigator.userAgent)
    payload.deviceModel = detectDeviceModel(window.navigator.userAgent)
    payload.osVersion = detectOsVersion(window.navigator.userAgent)
    val headers = js("{}")
    headers["Content-Type"] = "application/json"
    headers["apikey"] = anon
    headers["Authorization"] = if (access.isNotBlank()) "Bearer $access" else "Bearer $anon"
    val init = js("{}")
    init.method = "POST"
    init.headers = headers
    init.body = JSON.stringify(payload)
    return try {
        val resp = window.fetch("$base/functions/v1/support-contact", init).unsafeCast<kotlin.js.Promise<dynamic>>().await()
        if (resp.ok as Boolean) {
            null
        } else {
            val text = (resp.text().unsafeCast<kotlin.js.Promise<String>>().await()).trim()
            if (text.isNotBlank()) text else "erreur serveur"
        }
    } catch (e: Throwable) {
        e.message ?: "erreur réseau"
    }
}

private fun detectBrowserName(ua: String): String {
    val l = ua.lowercase()
    return when {
        "firefox" in l -> "Firefox"
        "edg/" in l -> "Edge"
        "opr/" in l || "opera" in l -> "Opera"
        "chrome/" in l && "safari/" in l -> "Chrome"
        "safari/" in l && "chrome/" !in l -> "Safari"
        else -> "Inconnu"
    }
}

private fun detectOsVersion(ua: String): String {
    val lower = ua.lowercase()
    Regex("""android\s+([0-9]+(?:\.[0-9]+)?)""").find(lower)?.groupValues?.getOrNull(1)?.let {
        return it
    }
    Regex("""iphone os\s+([0-9_]+)""").find(lower)?.groupValues?.getOrNull(1)?.let {
        return it.replace('_', '.')
    }
    Regex("""windows nt\s+([0-9.]+)""").find(lower)?.groupValues?.getOrNull(1)?.let {
        return it
    }
    return "n/a"
}

private fun detectDeviceModel(ua: String): String {
    val raw = Regex("""\(([^)]+)\)""").find(ua)?.groupValues?.getOrNull(1).orEmpty()
    if (raw.isBlank()) return "n/a"
    return raw.split(";").map { it.trim() }
        .firstOrNull { it.isNotBlank() && !it.contains("android", true) && !it.contains("linux", true) && !it.contains("mobile", true) }
        ?: raw
}

private fun StyleScope.supportFieldLabel() {
    margin(4.px, 0.px, 2.px, 0.px)
    color(Color("#475569"))
    fontSize(14.px)
    property("font-weight", "600")
}

private fun StyleScope.supportInputBox() {
    width(100.percent)
    padding(10.px)
    backgroundColor(Color("#F8FAFC"))
    color(Color("#0F172A"))
    property("border", "1px solid #CBD5E1")
    property("border-radius", "12px")
    property("box-sizing", "border-box")
    property("font-size", "16px")
}

private fun StyleScope.supportTextAreaBox() {
    width(100.percent)
    minHeight(110.px)
    padding(10.px)
    backgroundColor(Color("#F8FAFC"))
    color(Color("#0F172A"))
    property("border", "1px solid #CBD5E1")
    property("border-radius", "12px")
    property("box-sizing", "border-box")
    property("font-size", "16px")
    property("resize", "vertical")
}

private fun StyleScope.supportCategoryRow() {
    display(DisplayStyle.Flex)
    flexWrap(FlexWrap.Wrap)
    gap(8.px)
    width(100.percent)
}

private fun StyleScope.supportCategoryChip(active: Boolean) {
    padding(8.px, 10.px)
    minHeight(42.px)
    color(if (active) Color.white else Color("#0F172A"))
    backgroundColor(if (active) Color("#0EA5E9") else Color("#E2E8F0"))
    property("border", if (active) "1px solid #7DD3FC" else "1px solid #CBD5E1")
    property("border-radius", "999px")
    property("font-size", "14px")
    property("font-weight", "700")
    property("cursor", "pointer")
    property("text-transform", "capitalize")
}

private fun suggestedSummaryForCategory(category: String): String =
    when (category) {
        "rapport_bug" -> "Un bug empêche l'application de fonctionner correctement."
        "demande_developpement" -> "Je souhaite demander une nouvelle fonctionnalité."
        else -> "Je souhaite contacter le support."
    }

private fun buildEncryptedBugLogPayload(report: SupportReportDraft): String? {
    val payload =
        buildString {
            append("{")
            append("\"app\":\"histoire-du-soir-web\",")
            append("\"version\":\"support-export-v1\",")
            append("\"generated_at\":\"${js("new Date().toISOString()").unsafeCast<String>()}\",")
            append("\"url\":\"${window.location.href.replace("\"", "'")}\",")
            append("\"user_agent\":\"${window.navigator.userAgent.replace("\"", "'")}\",")
            append("\"language\":\"${window.navigator.language.replace("\"", "'")}\",")
            append("\"screen_label\":\"${report.screenLabel.replace("\"", "'")}\",")
            append("\"category\":\"${report.category.replace("\"", "'")}\",")
            append("\"summary\":\"${report.summary.replace("\"", "'")}\",")
            append("\"technical_note\":\"${report.technicalNote.replace("\"", "'")}\"")
            append("}")
        }
    return runCatching {
        js(
            """(function(payload){
              function toUtf8(str){ return new TextEncoder().encode(str); }
              function b64(bytes){
                var s = '';
                for (var i = 0; i < bytes.length; i++) s += String.fromCharCode(bytes[i]);
                return btoa(s);
              }
              function fromNumLE(n, size){
                var out = new Uint8Array(size);
                for (var i = 0; i < size; i++) out[i] = (n >>> (8 * i)) & 0xff;
                return out;
              }
              function crc32(bytes){
                var table = crc32.table || (crc32.table = (function(){
                  var t = new Uint32Array(256);
                  for (var i=0;i<256;i++){
                    var c=i;
                    for (var j=0;j<8;j++) c=((c&1)?(0xedb88320^(c>>>1)):(c>>>1));
                    t[i]=c>>>0;
                  }
                  return t;
                })());
                var crc = 0 ^ (-1);
                for (var k=0;k<bytes.length;k++) crc = (crc >>> 8) ^ table[(crc ^ bytes[k]) & 0xff];
                return (crc ^ (-1)) >>> 0;
              }
              function concat(arrays){
                var total = arrays.reduce(function(acc,a){ return acc + a.length; }, 0);
                var out = new Uint8Array(total);
                var off = 0;
                arrays.forEach(function(a){ out.set(a, off); off += a.length; });
                return out;
              }
              function xorEncrypt(bytes, keyBytes){
                var out = new Uint8Array(bytes.length);
                for (var i=0;i<bytes.length;i++){
                  out[i] = bytes[i] ^ keyBytes[i % keyBytes.length];
                }
                return out;
              }
              function dosDateTime(d){
                var year = d.getFullYear();
                if (year < 1980) year = 1980;
                var date = ((year - 1980) << 9) | ((d.getMonth() + 1) << 5) | d.getDate();
                var time = (d.getHours() << 11) | (d.getMinutes() << 5) | ((d.getSeconds() / 2) | 0);
                return { date: date, time: time };
              }
              var passphrase = "HDS_SUPPORT_LOG_ZIP_2026";
              var keyBytes = toUtf8(passphrase);
              var encrypted = xorEncrypt(toUtf8(payload), keyBytes);
              var envelope = JSON.stringify({
                alg: "XOR-UTF8",
                key_hint: "HDS_SUPPORT_LOG_ZIP_2026",
                ciphertext_b64: b64(encrypted)
              });
                return envelope;
            })""",
        )(payload).unsafeCast<String?>()
    }.getOrNull()
}

@Composable
private fun storyThemeButton(
    label: String,
    selected: Boolean,
    theme: ResolvedReaderTheme,
    onClick: () -> Unit,
) {
    Button(attrs = {
        onClick { onClick() }
        style { selectorButton(theme, selected) }
    }) { Text(label) }
}

@Composable
private fun adminLinkLine(label: String, url: String) {
    Div(attrs = {
        style { adminLinkRowContainer() }
        attr("title", "Ouvrir dans un nouvel onglet : $url")
    }) {
        Text("$label : ")
        Button(attrs = {
            attr("type", "button")
            onClick {
                val opened =
                    window.open(url, "_blank", "noopener,noreferrer")
                if (opened == null) {
                    window.alert(
                        "Le navigateur a bloqué la nouvelle fenêtre. Autorise les pop-ups pour ce site ou copie-colle le lien.",
                    )
                }
            }
            attr("title", "$url — nouvel onglet")
            style { adminLinkAsTextButton() }
        }) {
            Text(url)
        }
    }
}

private data class InviteProfile(
    val inviteCode: String,
    val displayName: String,
    val welcomeMessage: String,
    val themeLabel: String,
    val defaultPrompt: String,
    val defaultStory: String,
    val avatar: String,
    val photoUrl: String,
    val lockName: Boolean,
    val isAdmin: Boolean
)

private fun personalizedProfile(): InviteProfile {
    val invite = inviteCode()?.lowercase()
    return when (invite) {
        "admin" -> InviteProfile(
            inviteCode = "admin",
            displayName = "Admin",
            welcomeMessage = "Gestion des accès invités",
            themeLabel = "Bleu nuit",
            defaultPrompt = "",
            defaultStory = "",
            avatar = "A",
            photoUrl = "",
            lockName = true,
            isAdmin = true
        )
        else -> InviteProfile(
            inviteCode = invite ?: "standard",
            displayName = "Ami",
            welcomeMessage = "Bienvenue dans ton atelier d'histoires du soir.",
            themeLabel = "Bleu nuit",
            defaultPrompt = "une aventure douce avant de dormir",
            defaultStory = "Un ami curieux commence une belle aventure et écrit la suite de son histoire.",
            avatar = "?",
            photoUrl = "",
            lockName = false,
            isAdmin = false
        )
    }
}

private fun buildStory(name: String, age: String, ageUnit: String, theme: String, prompt: String): String {
    val cleanName = name.trim().ifBlank { "Ton enfant" }.replaceFirstChar { it.uppercase() }
    val cleanAge = age.trim().ifBlank { "?" }
    val cleanPrompt = prompt.trim().ifBlank { "une aventure magique" }
    return "$cleanName ($cleanAge $ageUnit) vit $cleanPrompt. Dans l'ambiance $theme, l'histoire se termine avec un sourire et un beau rêve."
}

private fun familyStoryTitle(profiles: List<StoredChildProfile>): String {
    val names = profiles.map { it.firstName.trim().ifBlank { "?" }.replaceFirstChar { it.uppercase() } }
    return when (names.size) {
        0 -> "Histoire du soir"
        1 -> "Histoire pour ${names[0]}"
        else -> "Histoire pour ${names.dropLast(1).joinToString(", ")} et ${names.last()}"
    }
}

private fun familyChildrenSummaryText(profiles: List<StoredChildProfile>): String =
    profiles.joinToString(" · ") { p ->
        val a = ageDisplayForBirthDate(p.birthDateIso)
        val unitLabel = if (a.unit == "ans") "ans" else "mois"
        "${p.firstName.trim().ifBlank { "?" }.replaceFirstChar { it.uppercase() }} " +
            "(${a.value.trim().ifBlank { "?" }} $unitLabel)"
    }

private fun buildStoryMulti(profiles: List<StoredChildProfile>, theme: String, prompt: String): String {
    val cleanPrompt = prompt.trim().ifBlank { "une aventure magique" }
    val bits = profiles.map { p ->
        val a = ageDisplayForBirthDate(p.birthDateIso)
        val unitLabel = if (a.unit == "ans") "ans" else "mois"
        "${p.firstName.trim().ifBlank { "Enfant" }.replaceFirstChar { it.uppercase() }} " +
            "(${a.value.trim().ifBlank { "?" }} $unitLabel)"
    }
    return "${bits.joinToString(", ")} vivent $cleanPrompt ensemble. Dans l'ambiance $theme, " +
        "l'histoire se termine avec un sourire et un beau rêve."
}

@Serializable
private data class ApiStoryChildLine(
    val name: String,
    val age: String,
    val ageUnit: String,
)

@Serializable
private data class ApiStoryRequest(
    val inviteCode: String,
    val name: String,
    val age: String,
    val ageUnit: String,
    val theme: String,
    val prompt: String,
    val children: List<ApiStoryChildLine>? = null,
    /** Jeton utilisateur : la Pages Function lit `groq_api_key` côté serveur (jamais la clé dans le client). */
    val supabaseAccessToken: String? = null,
)

@Serializable
private data class ApiStoryResponse(
    val title: String? = null,
    val story: String? = null,
    val error: String? = null,
    val details: String? = null
)

private data class WeeklyTheme(val label: String, val prompt: String, val uiTheme: String)

private fun baseWeeklyThemes(): List<WeeklyTheme> = listOf(
    WeeklyTheme("Animaux", "une aventure avec un animal courageux", "Vert emeraude"),
    WeeklyTheme("Magie", "une quête magique dans un royaume enchanté", "Violet doux"),
    WeeklyTheme("Espace", "un voyage dans l'espace avec des étoiles amies", "Bleu nuit"),
    WeeklyTheme("Océan", "une plongée dans l'océan avec des poissons lumineux", "Bleu nuit"),
    WeeklyTheme("Dinosaures", "une aventure avec un dinosaure gentil dans une vallée secrète", "Vert emeraude"),
    WeeklyTheme("Princesse", "une princesse courageuse sauve son château enchanté", "Violet doux"),
    WeeklyTheme("Super-héros", "un super-héros apprend à voler pour aider ses amis", "Bleu nuit"),
    WeeklyTheme("Nature", "une aventure dans la nature avec des arbres magiques", "Vert emeraude"),
    WeeklyTheme("Chevaliers", "de jeunes chevaliers protègent un royaume en fête", "Violet doux"),
    WeeklyTheme("Voyage", "un grand voyage autour du monde en ballon", "Bleu nuit")
)

private fun preconfiguredThemesForInvite(inviteCode: String, weekShift: Int = 0): List<WeeklyTheme> {
    val themes = baseWeeklyThemes()
    val weekIndex = ((js("Date.now()") as Double) / (1000 * 60 * 60 * 24 * 7)).toInt() + weekShift
    val inviteOffset = inviteCode.lowercase().sumOf { it.code } % themes.size
    val startIndex = (weekIndex + inviteOffset) % themes.size
    return themes.drop(startIndex) + themes.take(startIndex)
}

private fun deepenWeeklyThemeOptionsForHome(
    weeklyTheme: WeeklyTheme
): List<WeeklyTheme> {
    val variantsByTheme = mapOf(
        "Animaux" to listOf(
            "Océan" to "une aventure avec des animaux marins bienveillants dans l'océan",
            "Forêt" to "une aventure en forêt avec des animaux protecteurs",
            "Savane" to "une aventure douce en savane avec des animaux courageux",
            "Jungle" to "une exploration joyeuse dans la jungle avec des animaux amis",
            "Montagne" to "une balade en montagne avec des animaux malicieux",
            "Ferme" to "une histoire chaleureuse à la ferme avec des animaux attachants",
            "Banquise" to "une mission tendre en banquise avec des animaux polaires"
        ),
        "Magie" to listOf(
            "Sortilèges" to "une aventure autour de sortilèges bienveillants et étincelants",
            "Potion" to "une quête pour préparer une potion magique pleine de douceur",
            "École de magie" to "une journée à l'école de magie avec un défi joyeux",
            "Baguette" to "une mission avec une baguette magique qui aide les amis",
            "Forêt enchantée" to "une découverte d'une forêt enchantée lumineuse",
            "Livre magique" to "une aventure guidée par un livre magique ancien",
            "Portail secret" to "un passage par un portail secret vers un monde merveilleux"
        ),
        "Espace" to listOf(
            "Planètes" to "un voyage entre des planètes colorées et amicales",
            "Étoiles" to "une aventure parmi les étoiles scintillantes",
            "Fusée" to "une mission en fusée pour aider un ami de l'espace",
            "Comètes" to "une course douce avec des comètes lumineuses",
            "Galaxie" to "une exploration d'une galaxie pleine de merveilles",
            "Station spatiale" to "une visite joyeuse dans une station spatiale",
            "Lune" to "une aventure apaisante sur la lune"
        ),
        "Océan" to listOf(
            "Corail" to "une plongée autour d'un récif corallien magique",
            "Dauphins" to "une aventure avec des dauphins joueurs et gentils",
            "Trésor marin" to "une chasse au trésor marin pleine d'entraide",
            "Île secrète" to "une découverte d'une île secrète au milieu de l'océan",
            "Baleines" to "une rencontre apaisante avec des baleines majestueuses",
            "Sous-marin" to "un voyage en sous-marin dans des eaux lumineuses",
            "Lagons" to "une aventure douce dans des lagons turquoise"
        ),
        "Dinosaures" to listOf(
            "Vallée perdue" to "une exploration d'une vallée perdue de dinosaures gentils",
            "Œuf mystère" to "une mission pour protéger un œuf de dinosaure",
            "Volcan doux" to "une aventure près d'un volcan paisible avec des dinosaures amis",
            "Forêt jurassique" to "une promenade dans une forêt jurassique lumineuse",
            "Tricératops" to "une histoire avec un tricératops courageux",
            "Ptéranodon" to "un vol magique avec un ptéranodon protecteur",
            "Parade dinos" to "une grande fête avec une parade de dinosaures"
        ),
        "Princesse" to listOf(
            "Château" to "une mission au château pour préparer une fête royale",
            "Couronne" to "une aventure autour d'une couronne magique",
            "Bal royal" to "les préparatifs d'un bal royal plein de joie",
            "Jardin enchanté" to "une découverte d'un jardin enchanté du palais",
            "Carrosse" to "un voyage en carrosse vers un royaume voisin",
            "Tour secrète" to "une quête dans une tour secrète lumineuse",
            "Amitié royale" to "une histoire de grande amitié entre jeunes princesses"
        ),
        "Super-héros" to listOf(
            "Pouvoirs" to "une aventure pour découvrir des pouvoirs bienveillants",
            "Ville lumineuse" to "une mission pour aider la ville lumineuse",
            "Équipe héroïque" to "une mission en équipe de super-héros solidaires",
            "Cape volante" to "un vol magique avec une cape héroïque",
            "QG secret" to "une journée dans le QG secret des héros",
            "Sauvetage" to "un sauvetage doux et courageux d'un ami",
            "Médaille" to "une aventure qui se termine par une médaille de bravoure"
        ),
        "Nature" to listOf(
            "Forêt" to "une aventure dans une forêt vivante et lumineuse",
            "Océan" to "une découverte de l'océan et de ses merveilles",
            "Montagne" to "une randonnée douce vers une montagne magique",
            "Prairie" to "une balade joyeuse dans une grande prairie fleurie",
            "Rivière" to "une mission bienveillante près d'une rivière scintillante",
            "Jardin" to "une aventure au jardin avec des plantes extraordinaires",
            "Saisons" to "un voyage à travers les saisons de la nature"
        ),
        "Chevaliers" to listOf(
            "Château" to "une mission de chevaliers au château",
            "Princesse" to "une aventure de chevaliers pour aider une princesse courageuse",
            "Dragon" to "une rencontre avec un dragon gentil à protéger",
            "Tournoi" to "un tournoi de chevaliers basé sur l'entraide",
            "Épée magique" to "une quête autour d'une épée magique légendaire",
            "Pont du royaume" to "une mission pour sécuriser le pont du royaume",
            "Carte secrète" to "une aventure guidée par une carte secrète du royaume"
        ),
        "Voyage" to listOf(
            "Désert" to "un voyage doux dans le désert aux dunes dorées",
            "Japon" to "une aventure culturelle joyeuse au Japon",
            "Afrique" to "une découverte chaleureuse des paysages d'Afrique",
            "Pôle Nord" to "une expédition apaisante au pôle Nord",
            "Îles" to "un voyage d'île en île avec des surprises",
            "Train magique" to "un tour du monde en train magique",
            "Ballon" to "un grand voyage en montgolfière colorée"
        )
    )

    val selectedVariants = variantsByTheme[weeklyTheme.label] ?: listOf(
        "Aventure principale" to weeklyTheme.prompt,
        "Mission" to "une mission inspirée du thème ${weeklyTheme.label.lowercase()}",
        "Découverte" to "une découverte inspirée du thème ${weeklyTheme.label.lowercase()}",
        "Quête" to "une quête douce inspirée du thème ${weeklyTheme.label.lowercase()}",
        "Duo d'amis" to "une aventure en duo inspirée du thème ${weeklyTheme.label.lowercase()}",
        "Secret" to "un secret bienveillant lié au thème ${weeklyTheme.label.lowercase()}",
        "Finale" to "une belle finale inspirée du thème ${weeklyTheme.label.lowercase()}"
    )

    return selectedVariants.map { (label, prompt) ->
        WeeklyTheme(label = label, prompt = prompt, uiTheme = weeklyTheme.uiTheme)
    }
}

private fun themesWithWeeklyFirst(weeklyTheme: WeeklyTheme): List<WeeklyTheme> {
    val themes = baseWeeklyThemes()
    return listOf(weeklyTheme) + themes.filter { it.label != weeklyTheme.label }
}

private fun weeklyThemeForInvite(inviteCode: String, weekShift: Int = 0): WeeklyTheme {
    return preconfiguredThemesForInvite(inviteCode, weekShift = weekShift).first()
}

private fun inviteCode(): String? {
    val search = window.location.search
    val queryInvite = search
        .removePrefix("?")
        .takeIf { it.isNotBlank() }
        ?.split("&")
        ?.mapNotNull {
            val parts = it.split("=")
            if (parts.size == 2 && parts[0] == "invite") parts[1] else null
        }
        ?.firstOrNull()

    if (!queryInvite.isNullOrBlank()) return normalizeInviteCode(queryInvite)

    val pathParts = window.location.pathname
        .removePrefix("/")
        .split("/")
        .filter { it.isNotBlank() }

    if (pathParts.isEmpty()) return null

    if (pathParts.size >= 2 && pathParts[0] == "invite") {
        return normalizeInviteCode(pathParts[1])
    }

    return normalizeInviteCode(pathParts[0])
}

private fun normalizeInviteCode(rawCode: String): String {
    return when (rawCode.lowercase()) {
        "a" -> "admin"
        else -> rawCode
    }
}

private fun backgroundForTheme(theme: String): CSSColorValue = when (theme) {
    "Bleu nuit" -> Color("#DBEAFE")
    "Violet doux" -> Color("#F3E8FF")
    "Vert emeraude" -> Color("#DCFCE7")
    else -> Color("#F8FAFC")
}

private fun StyleScope.pageContainer(
    background: CSSColorValue,
    customBackgroundDataUrl: String?,
    rootTextColor: CSSColorValue,
) {
    width(100.percent)
    minHeight(100.percent)
    display(DisplayStyle.Flex)
    justifyContent(JustifyContent.Center)
    alignItems(org.jetbrains.compose.web.css.AlignItems.Center)
    color(rootTextColor)
    fontFamily("'Trebuchet MS', 'Arial Rounded MT Bold', Arial, sans-serif")
    padding(16.px)
    property("box-sizing", "border-box")
    val custom = customBackgroundDataUrl?.trim().orEmpty()
    if (custom.isNotBlank() && custom.startsWith("data:image/")) {
        val safe = custom.replace("\\", "\\\\").replace("'", "\\'")
        backgroundColor(Color("#0f172a"))
        property(
            "background-image",
            "linear-gradient(rgba(15,23,42,0.78), rgba(15,23,42,0.78)), url('$safe')",
        )
        property("background-size", "cover")
        property("background-position", "center")
        property("background-repeat", "no-repeat")
        property("background-attachment", "fixed")
    } else {
        backgroundColor(background)
        property(
            "background-image",
            "radial-gradient(circle at top, rgba(255,255,255,0.72), transparent 36%)",
        )
    }
}

/** Même cadrage que l’ancienne carte, sans panneau : texte et champs directement sur le fond. */
private fun StyleScope.appCard() {
    width(100.percent)
    maxWidth(520.px)
    display(DisplayStyle.Flex)
    flexDirection(FlexDirection.Column)
    gap(14.px)
    padding(18.px)
    backgroundColor(Color.transparent)
    property("border-radius", "24px")
    property("border", "none")
    property("box-shadow", "none")
    property("backdrop-filter", "none")
}

private fun StyleScope.readerMainColumn(theme: ResolvedReaderTheme) {
    width(100.percent)
    display(DisplayStyle.Flex)
    flexDirection(FlexDirection.Column)
    gap(14.px)
    property("box-sizing", "border-box")
    if (theme.backdropEnabled && theme.backdropCss != "transparent") {
        property("background", theme.backdropCss)
        padding(14.px)
        property("border-radius", "18px")
        property("border", "1px solid rgba(148, 163, 184, 0.28)")
        property("box-shadow", "0 10px 36px rgba(0,0,0,0.18)")
    }
}

private fun StyleScope.avatarBadge() {
    width(72.px)
    minHeight(72.px)
    display(DisplayStyle.Flex)
    justifyContent(JustifyContent.Center)
    alignItems(org.jetbrains.compose.web.css.AlignItems.Center)
    backgroundColor(Color("#F59E0B"))
    fontSize(30.px)
    property("border-radius", "20px")
    property("color", "#1E293B")
    property("box-shadow", "0 10px 26px rgba(245, 158, 11, 0.28)")
}

private fun StyleScope.photoStyle() {
    display(DisplayStyle.Block)
    width(112.px)
    minHeight(112.px)
    property("margin", "0 auto")
    property("border-radius", "20px")
    property("object-fit", "cover")
    property("border", "4px solid rgba(255,255,255,0.34)")
    property("box-shadow", "0 12px 28px rgba(236, 72, 153, 0.20)")
}

private fun StyleScope.storyCard() {
    display(DisplayStyle.Flex)
    flexDirection(FlexDirection.Column)
    gap(10.px)
    width(100.percent)
    padding(14.px)
    margin(0.px)
    backgroundColor(Color.transparent)
    property("border-radius", "18px")
    property("border", "none")
    property("box-sizing", "border-box")
}

private fun StyleScope.titleText(theme: ResolvedReaderTheme) {
    margin(2.px)
    textAlign("center")
    color(theme.primary)
    property("line-height", "1.15")
    property("font-weight", "800")
}

private fun StyleScope.centeredMedia() {
    display(DisplayStyle.Flex)
    justifyContent(JustifyContent.Center)
    alignItems(org.jetbrains.compose.web.css.AlignItems.Center)
    width(100.percent)
}

private fun StyleScope.descriptionText(theme: ResolvedReaderTheme) {
    color(theme.secondary)
    fontSize(16.px)
    margin(4.px)
    property("line-height", "1.5")
}

private fun StyleScope.adminLinkRowContainer() {
    color(Color("#E2E8F0"))
    fontSize(16.px)
    margin(4.px)
    property("line-height", "1.5")
}

private fun StyleScope.adminLinkAsTextButton() {
    color(Color("#BAE6FD"))
    fontSize(16.px)
    property("font-weight", "700")
    property("text-decoration", "underline")
    property("text-underline-offset", "3px")
    property("word-break", "break-all")
    backgroundColor(Color("transparent"))
    property("border", "none")
    padding(0.px)
    margin(0.px)
    property("cursor", "pointer")
    property("display", "inline")
    property("font-family", "inherit")
    property("vertical-align", "baseline")
    property("box-shadow", "none")
}

private fun StyleScope.labelText(theme: ResolvedReaderTheme) {
    color(theme.label)
    fontSize(15.px)
    margin(4.px)
    property("font-weight", "600")
}

private fun StyleScope.formRow() {
    display(DisplayStyle.Flex)
    gap(10.px)
    flexDirection(FlexDirection.Column)
    flexWrap(FlexWrap.Wrap)
    justifyContent(JustifyContent.FlexStart)
    width(100.percent)
}

private fun StyleScope.formField() {
    display(DisplayStyle.Flex)
    flexDirection(FlexDirection.Column)
    width(100.percent)
    maxWidth(360.px)
}

private fun StyleScope.firstNameField() {
    display(DisplayStyle.Flex)
    flexDirection(FlexDirection.Column)
    width(100.percent)
    maxWidth(100.percent)
    property("box-sizing", "border-box")
}

private fun StyleScope.ageField() {
    display(DisplayStyle.Flex)
    flexDirection(FlexDirection.Column)
    width(100.percent)
    maxWidth(100.percent)
    property("box-sizing", "border-box")
}

private fun StyleScope.inputBox(theme: ResolvedReaderTheme) {
    width(100.percent)
    padding(12.px)
    if (theme.lightForeground) {
        backgroundColor(Color("rgba(255, 255, 255, 0.10)"))
        color(Color.white)
        property("border", "1px solid rgba(255,255,255,0.22)")
    } else {
        backgroundColor(Color("#F8FAFC"))
        color(Color("#0F172A"))
        property("border", "2px solid #CBD5E1")
    }
    property("border-radius", "14px")
    property("box-sizing", "border-box")
    property("font-size", "16px")
}

private fun StyleScope.themeSelectorRow() {
    display(DisplayStyle.Flex)
    gap(8.px)
    margin(4.px)
    flexWrap(FlexWrap.Wrap)
}

private fun StyleScope.selectorButton(theme: ResolvedReaderTheme, active: Boolean) {
    padding(10.px)
    color(if (theme.lightForeground) Color.white else Color("#0F172A"))
    backgroundColor(
        when {
            active && theme.lightForeground -> Color("#F472B6")
            active -> Color("#DB2777")
            theme.lightForeground -> Color("rgba(255,255,255,0.10)")
            else -> Color("rgba(15,23,42,0.08)")
        },
    )
    property(
        "border",
        when {
            active && theme.lightForeground -> "1px solid #FBCFE8"
            active -> "1px solid #FBCFE8"
            theme.lightForeground -> "1px solid rgba(255,255,255,0.18)"
            else -> "1px solid #CBD5E1"
        },
    )
    property("border-radius", "999px")
    property("font-weight", "600")
    property("font-size", "15px")
    property("min-height", "44px")
    property("box-shadow", if (active) "0 6px 18px rgba(244, 114, 182, 0.32)" else "none")
}

private fun StyleScope.generateButton() {
    width(100.percent)
    minHeight(52.px)
    padding(12.px)
    color(Color.white)
    backgroundColor(Color("#FB7185"))
    property("border", "1px solid #FECDD3")
    property("border-radius", "16px")
    property("font-weight", "700")
    property("box-shadow", "0 10px 22px rgba(251, 113, 133, 0.28)")
    property("font-size", "16px")
}

private fun StyleScope.clearButton() {
    minHeight(46.px)
    padding(10.px)
    color(Color.white)
    backgroundColor(Color("#8B5CF6"))
    property("border", "1px solid #C4B5FD")
    property("border-radius", "14px")
    property("font-weight", "600")
    property("font-size", "15px")
}

private fun StyleScope.storyText(theme: ResolvedReaderTheme) {
    color(theme.storyBody)
    fontSize(17.px)
    property("line-height", "1.75")
    property("white-space", "pre-wrap")
    if (theme.lightForeground) {
        property(
            "text-shadow",
            "0 1px 2px rgba(15,23,42,0.85), 0 0 18px rgba(15,23,42,0.55)",
        )
    } else {
        property("text-shadow", "none")
    }
}

private fun StyleScope.storyReadingTitle(theme: ResolvedReaderTheme) {
    color(theme.storyTitle)
    fontSize(18.px)
    margin(4.px)
    property("font-weight", "700")
    if (theme.lightForeground) {
        property(
            "text-shadow",
            "0 1px 2px rgba(15,23,42,0.9), 0 0 16px rgba(15,23,42,0.5)",
        )
    } else {
        property("text-shadow", "none")
    }
}

private fun StyleScope.storyFormBackButton(theme: ResolvedReaderTheme) {
    property("align-self", "flex-start")
    margin(0.px, 0.px, 8.px, 0.px)
    padding(10.px, 12.px)
    if (theme.lightForeground) {
        color(Color("#E0F2FE"))
        backgroundColor(Color("rgba(255,255,255,0.12)"))
        property("border", "1px solid rgba(255,255,255,0.28)")
    } else {
        color(Color("#0F172A"))
        backgroundColor(Color("rgba(248,250,252,0.85)"))
        property("border", "2px solid #CBD5E1")
    }
    property("border-radius", "14px")
    property("font-weight", "600")
    property("cursor", "pointer")
}

private fun StyleScope.errorText() {
    color(Color("#FCA5A5"))
    fontSize(14.px)
    margin(2.px)
}

private fun StyleScope.customBadge() {
    color(Color("#0F172A"))
    backgroundColor(Color("#FDE68A"))
    padding(8.px)
    property("border-radius", "999px")
    property("display", "inline-block")
    fontSize(14.px)
    margin(2.px)
    property("font-weight", "700")
}

private fun StyleScope.ageRow() {
    display(DisplayStyle.Flex)
    gap(8.px)
    alignItems(org.jetbrains.compose.web.css.AlignItems.Center)
}

private fun StyleScope.ageInputBox(theme: ResolvedReaderTheme) {
    width(100.percent)
    padding(12.px)
    if (theme.lightForeground) {
        backgroundColor(Color("rgba(255, 255, 255, 0.10)"))
        color(Color.white)
        property("border", "1px solid rgba(255,255,255,0.22)")
    } else {
        backgroundColor(Color("#F8FAFC"))
        color(Color("#0F172A"))
        property("border", "2px solid #CBD5E1")
    }
    property("border-radius", "14px")
    property("font-size", "16px")
}

private fun StyleScope.unitSliderButton() {
    padding(10.px)
    color(Color.white)
    backgroundColor(Color("#14B8A6"))
    property("border", "1px solid #99F6E4")
    property("border-radius", "14px")
    property("font-weight", "600")
}

private fun StyleScope.storyErrorOverlay() {
    property("position", "fixed")
    property("inset", "0")
    property("z-index", "9999")
    backgroundColor(Color("rgba(2, 6, 23, 0.72)"))
    display(DisplayStyle.Flex)
    justifyContent(JustifyContent.Center)
    alignItems(org.jetbrains.compose.web.css.AlignItems.Center)
    padding(16.px)
    property("box-sizing", "border-box")
}

private fun StyleScope.storyErrorCard() {
    width(100.percent)
    maxWidth(96.percent)
    property("max-width", "560px")
    padding(20.px)
    backgroundColor(Color("#FFFFFF"))
    property("border-radius", "16px")
    property("box-shadow", "0 20px 50px rgba(15, 23, 42, 0.40)")
    display(DisplayStyle.Flex)
    flexDirection(FlexDirection.Column)
    gap(12.px)
}

private fun StyleScope.storyErrorTitle() {
    margin(0.px)
    color(Color("#0F172A"))
    fontSize(20.px)
    property("font-weight", "800")
}

private fun StyleScope.storyErrorBody() {
    margin(0.px)
    color(Color("#334155"))
    fontSize(15.px)
    property("line-height", "1.5")
}

private fun StyleScope.storyErrorButtons() {
    display(DisplayStyle.Flex)
    flexDirection(FlexDirection.Column)
    gap(8.px)
    width(100.percent)
    property("flex-wrap", "wrap")
}

private fun StyleScope.storyErrorPrimaryButton() {
    width(100.percent)
    minHeight(46.px)
    padding(10.px, 14.px)
    color(Color.white)
    backgroundColor(Color("#0EA5E9"))
    property("border", "1px solid #7DD3FC")
    property("border-radius", "12px")
    property("font-weight", "700")
    property("font-size", "16px")
}

private fun StyleScope.storyErrorSecondaryButton() {
    width(100.percent)
    minHeight(46.px)
    padding(10.px, 14.px)
    color(Color("#0F172A"))
    backgroundColor(Color("#E2E8F0"))
    property("border", "1px solid #CBD5E1")
    property("border-radius", "12px")
    property("font-weight", "700")
    property("font-size", "16px")
}
